import { useEffect, useMemo } from 'react';

import {
  Dropdown,
  DropdownChip,
  DropdownContent,
  DropdownRadioGroup,
  DropdownRadioItem,
  DropdownTrigger,
} from '@mesh.ai/rabbit';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import {
  setSelectedViewByEngagementIntent,
  useSelectEngagementSelectedViewBy,
  useSelectEngagementViewByOptions,
} from '../slice/EngagementIntentSlice';

const EngagementViewByDropdown = () => {
  const dispatch = useDispatch();
  const viewByOptions = useSelectEngagementViewByOptions();
  const selectedViewBy = useSelectEngagementSelectedViewBy();

  const history = useHistory();
  const { search } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);

  const onViewByChange = (value) => {
    dispatch(setSelectedViewByEngagementIntent(value));
    searchParams.set('viewBy', value.uuid);
    history.push({
      search: searchParams.toString(),
    });
  };

  const viewByURLQueryParam = searchParams.get('viewBy');

  useEffect(() => {
    if (!viewByURLQueryParam) {
      searchParams.set('viewBy', viewByOptions[0].uuid);
      dispatch(
        setSelectedViewByEngagementIntent({
          value: viewByOptions[0]?.keyName || '',
          label: viewByOptions[0]?.displayName || '',
          uuid: viewByOptions[0]?.uuid || '',
        })
      );

      history.push({
        search: searchParams.toString(),
      });
    }
  }, [dispatch, history, searchParams, viewByOptions, viewByURLQueryParam]);

  useEffect(() => {
    if (viewByURLQueryParam && viewByURLQueryParam !== selectedViewBy?.value) {
      const foundOption = viewByOptions.find(({ keyName }) => keyName === viewByURLQueryParam);
      if (foundOption) {
        dispatch(
          setSelectedViewByEngagementIntent({
            value: foundOption.keyName,
            label: foundOption.displayName,
            uuid: foundOption.uuid,
          })
        );
      }
    }
  }, [dispatch, selectedViewBy?.value, viewByOptions, viewByURLQueryParam]);

  return (
    <Dropdown>
      <DropdownTrigger asChild>
        <DropdownChip className="chip-dropdown">
          <TextBodyMedium bold color="text.g2" className="group-data[state=open]:text-[#004F67]">
            View by :
          </TextBodyMedium>
          <TextBodyMedium bold color="text.g1">
            {selectedViewBy?.label ?? ''}
          </TextBodyMedium>
        </DropdownChip>
      </DropdownTrigger>
      <DropdownContent align="start" style={{ minWidth: '200px' }}>
        <DropdownRadioGroup value={selectedViewBy?.value}>
          {viewByOptions?.map(({ displayName, uuid, keyName }) => (
            <DropdownRadioItem
              key={uuid}
              value={keyName}
              onClick={() =>
                onViewByChange({
                  value: keyName,
                  label: displayName,
                  uuid,
                })
              }
            >
              {displayName}
            </DropdownRadioItem>
          ))}
        </DropdownRadioGroup>
      </DropdownContent>
    </Dropdown>
  );
};

export { EngagementViewByDropdown };
